module.exports = __webpack_public_path__ + "img/DSC_1108.e7a24a84.jpg";